export const routerPath = {
  main: '/',
  loginPage: '/login-page',
  registerPage: '/register-page'
};
